
import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { formatOneDecimal } from '@/common/utils/common'
//@ts-ignore
import Swiper from 'swiper/dist/js/swiper.min.js'
import chunk from 'lodash/chunk'
import { BQ_EVENT_NAMES, BQ_AWS_PERSONALIZE_AREA_NAME, raksulBQEventTracker } from '../utils/eventTracker'
import FavoriteBtn from '@/common/components/FavoriteBtn.vue'

export default Vue.extend({
  components: {
    BaseImage,
    FavoriteBtn
  },
  props: {
    productList: {
      type: Array,
      required: true
    },
    trackingPageType: {
      type: String,
      required: true
    },
    trackingRecommendationLogic: {
      type: String,
      required: true
    },
    trackingPageArea: {
      type: String,
      required: false,
      default: BQ_AWS_PERSONALIZE_AREA_NAME.RIGHT_SIDE
    },
    sectionTitle: {
      type: String,
      required: true
    },
    wrapperClass: {
      type: String,
      default: undefined
    },
    slideClass: {
      type: String,
      default: undefined
    },
    itemClass: {
      type: String,
      default: undefined
    },
    swiperOptions: {
      type: Object,
      default: undefined
    },
    itemsPerSlide: {
      type: Number,
      default: 4
    },
    hasFavorite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: undefined,
      currentPage: 1
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    chunkProductItems() {
      return chunk(this.productList, this.itemsPerSlide)
    },
    total() {
      return Math.ceil(this.productList.length / this.itemsPerSlide)
    },
    isHasFavorite(): boolean {
      return this.hasFavorite
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    formatOneDecimal,
    nextPage() {
      if (this.currentPage === this.total) {
        this.currentPage = 1
      } else {
        this.currentPage = ++this.currentPage
      }
    },
    previousPage() {
      if (this.currentPage === 1) {
        this.currentPage = this.total
      } else {
        this.currentPage = --this.currentPage
      }
    },
    navigateToProductDetail(event: PointerEvent) {
      const target = event.target as HTMLElement
      const productItem = target.closest('[data-type="productItem"]')
      if (!productItem) return
      const productId = productItem.getAttribute('data-product-id')
      if (!productId) return
      raksulBQEventTracker({
          eventName: BQ_EVENT_NAMES.CLICK_AWS_PERSONALIZE,
          data: {
            productId,
            recommendationLogic: this.trackingRecommendationLogic,
            pageType: this.trackingPageType,
            areaName: this.trackingPageArea
          }
        })
      location.href = `/products/${productId}`
    },
    initSwiper() {
      const className = 'sw-RecProduct_CarouselWrapper'
      this.swiper = new Swiper(`.${className}`, {
        spaceBetween: 0,
        pagination: false,
        slidesPerView: 1,
        threshold: 2,
        loop: true,
        lazy: {
          loadPrevNext: false
        },
        navigation: {
          nextEl: '.sw-RecProduct_Wrapper .sw-RecProduct_PaginationBtnNext',
          prevEl: '.sw-RecProduct_Wrapper .sw-RecProduct_PaginationBtnPrev'
        },
        on: {
          init: function() {
            if (window.lazyLoadInstance) {
              window.lazyLoadInstance.update()
            }
          },
          slideChange: () => {
            // @ts-ignore
            if (this.swiper?.swipeDirection) {
              // @ts-ignore
              if (this.swiper?.touches?.diff < 0) { this.nextPage() }
              else { this.previousPage() }
            }
          }
        },
        ...this.swiperOptions
      })
    }
  }
})
